const headingTypes = new Set(["contentHeading", "subheading", "ruleLabel", "guidanceStart"]);
const contextTypes = new Set(["paragraph", ...headingTypes]);
const listTypes = new Set(["clause", "definition", "glossaryTable", "applicationTable"]);

// A selected list item needs its lead-in, even when that text does not match
// the search. Preserve source order and the filtered version of each item.
export default function preserveListContext(blocks, selectedBlocks) {
  if (!selectedBlocks.length) return [];

  const selected = new Map(selectedBlocks.map((block) => [block.id, block]));
  const contextIds = new Set();

  blocks.forEach((block, index) => {
    if (!selected.has(block.id)) return;

    if (listTypes.has(block.type)) {
      let start = index;
      while (start > 0 && blocks[start - 1].type === block.type) start -= 1;

      for (let previous = start - 1; previous >= 0; previous -= 1) {
        const context = blocks[previous];
        if (!contextTypes.has(context.type)) break;
        contextIds.add(context.id);
        if (headingTypes.has(context.type)) break;
      }
    }

    // Keep the local heading for matches later in a section, but do not pull
    // introductory paragraphs from a different rule or subsection.
    if (!headingTypes.has(block.type)) {
      for (let previous = index - 1; previous >= 0; previous -= 1) {
        if (headingTypes.has(blocks[previous].type)) {
          contextIds.add(blocks[previous].id);
          break;
        }
      }
    }
  });

  return blocks
    .filter((block) => selected.has(block.id) || contextIds.has(block.id))
    .map((block) => selected.get(block.id) || block);
}
